import commonLogoFull from '~/assets/images/logo_elearning_full.png';
import commonLogoFullPositive from '~/assets/images/logo_elearning_full_positive.png';
import commonLogoFullPositiveThumbnail from '~/assets/images/logo_elearning_full_positive_thumbnail.png';

const images = {
  commonLogoFull,
  commonLogoFullPositive,
  commonLogoFullPositiveThumbnail,
};

export default images;
